// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers, ElementRef, Renderer2, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';

// Imports DIAN
import { DLogger, DError, DParametrosServicioMuisca, DConfiguracionEndPoint } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica, DDatosCompartidosCabecera } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DParametrosPolitica, DParametroPolitica, DValorDominio, DLugar, DErrorResponse } from '@dian/api-basicos-parametricas';
//import { DReciboPago490v7Servicios, DObjetoEsResponsabilidad, DObjetoPagoPrimeraCuota } from '@dian-api/recibopagoconceptos490';
import { DAPIReciboPagoConceptos490Servicios } from '@dian-api/recibo-pago-conceptos490';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DActividadEconomica } from '@dian/api-rut/src/to/actividad-economica/dactividad-economica';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DDiligenciamientoParametricasServicios } from '@dian/api-diligenciamiento';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';

// Imports App
import { DFormularioConfiguracion } from '../../../configuracion/dformulario-configuracion';
import { DPreguntasFormulario } from '../../../configuracion/dpreguntas-formulario';
import { DAyudasFormulario } from '../../../configuracion/dayudas-formulario';
import { DArchivoBlob } from '@dian/api-formulario';
import { DatePipe } from '@angular/common';
import { DReciboPago490Servicios, DLiquidacionRecibo, DRtaLiquidacionReciboPago, DConceptoLiquidacionRecibo, DListEntidadesBancarias, DEntidadBancaria, DDeudorSolidarioSubsidiario, DValorMonetarioDetalle } from '@dian-api/recibo-pago490';
import { PagoComponent } from '../../../components/pago/pago.component';
import { DForm1 } from './form1';
import { DialogoImpuestoSimpleComponent } from '../dialogo-impuesto-simple/dialogoimpsimp.component';
import { DRol } from './drol';
import { ModalIdTributarioComponent } from '../../modal/modalidtributario.component';
import { EventEmitter } from 'events';
import { Parametros } from './parametros';
import { DValorPeriodico } from '@dian/api-basicos-parametricas/src/to/dvalor-periodico';





const tableStructure = [
  { id: 'conceptoPago', title: 'Concepto Pago' },
  { id: 'numDeclaracion', title: 'No Declaración' },
  { id: 'numDocumentoOrigen', title: 'No Documento Origen' },
  { id: 'valorImpuesto', title: 'Valor Impuesto' },
  { id: 'valorInteresMora', title: 'Valor Intereses Mora' },
  { id: 'valorSancion', title: 'Valor Sanción' },
  { id: 'total', title: 'Total' },

];
class Form1 {
  id: number;
  conceptoPago: number; //concepto de pago
  numDeclaracion: number; //valor venta
  numDocumentoOrigen: number; //valor compra
  valorImpuesto: number; //anio compra
  valorInteresMora: number; //valor impuesto pagado exterior
  valorSancion: number; //ubicacion accion
  total: number;
}


@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio,
    DUtilidadesFormularioServicio,
    DAPIReciboPagoConceptos490Servicios,
    DReciboPago490Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DReciboPagoDialogoServicio,
    DContextoUsuarioServicio,
    DBasicosParametricasServicios,
    DatePipe,
    PagoComponent,
  ]
})





export class FormularioComponent extends DFormulario implements OnInit {

    @Input()
    dDatosCompartidosCabecera: DDatosCompartidosCabecera;
    // @Output() parametrosCambio = new EventEmitter();
    

  public parametros: Parametros;
  public concepto;
  public anio;
  public periodicidad;
  public periodo;
  private UVT: string;
  private DIEZ_UVT: string;
  public origen: string;


  public anioActual; // Año actual
  public mesActual; // Mes actual 
  public fechaActual; // Fecha actual 

  public extemporaneo=false;


  public liquidacionRecibo:DLiquidacionRecibo;

  public fechaVencimiento;

  public habilitarCas34y35: boolean = true;
  public habilitarCas35: boolean = true;

  // 2026/02/03 concepto 7 habilita cas 30 y 31
  public concepto7=false;
  //deshabilitar casillas 27 y 28 sobre cuotas y número de cuota
  public deshabilitarCas27 = false;
  public deshabilitarCas28 = false;
  public deshabilitarCas33 = true;
  // public impuestosSimple: DialogoImpuestoSimpleComponent[] = Array<DialogoImpuestoSimpleComponent>();
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public impuestosSimple: DForm1[] = Array<DForm1>();

  // slide cards
  public cardDeclarante: boolean = true;
  public cardIngresos: boolean = true;
  public cardCompras: boolean = true;
  public cardLiquidacionPrivada: boolean = true;
  public cardControlSaldos: boolean = true;
  public cardAnticiposIVA: boolean = true;
  public cardFirmas: boolean = true;
  public cardImpuestosSimple: boolean = true;
  public ayudaDeclarante: boolean = false;
  public ayudaIngresos: boolean = false;
  public ayudaCompras: boolean = false;
  public ayudaLiquidacionPrivada: boolean = false;
  public ayudaControlSaldos: boolean = false;
  public ayudaAnticiposIVA: boolean = false;
  public ayudaFirmas: boolean = false;
  public ayudasBaseFormulario: DAyudasFormulario;
  // public dDatosCompartidosCabecera: DDatosCompartidosCabecera;
  public esRegimenSimple: boolean = false;
  public listCodigosConceptos: Array<DValorDominio>;
  public listCodigosConceptosTmp: Array<DValorDominio>;
  public cas2valor: string = "";
  public fechaPago: string;
  public minFecha: Date = new Date();
  public stateInput: { error: boolean, message: string, dateString: string };

  private parameters;

  private politica401: DParametrosPolitica;
  public tieneFirmaElectronica: boolean;
  public reciboPago: DRtaLiquidacionReciboPago;
  public seleccion: string;
  public usaPagoPSE: boolean;
  private numRepeticion: string;
  public modeloDeudorSolidario: DDeudorSolidarioSubsidiario;
  public listDptos: Array<DLugar>;
  public listMpios: Array<DLugar>;


  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  public modelForm: Form1 = new Form1();

  public cuentaFilasImpuestosSimple = [0];
  public rol = 3377;
  public roles;
 
  public habilitaRazonSocial: boolean = true;

  /**
  * @constructor
  */
  constructor(
    dialog: MatDialog,
    router: Router,
    dNotificacionServicio: DNotificacionServicio,
    dPreguntasDialogoServicio: DPreguntasDialogoServicio,
    activatedRoute: ActivatedRoute,
    dutilidades: DOperacionesMatematicasServicio,
    utilitariosForm: DUtilidadesFormularioServicio,
    dlogger: DLogger,
    private dRutServicios: DRutServicios,
    private dServicioRESTAPI: DAPIReciboPagoConceptos490Servicios,  // Servicio de ejemplo (debe ser cambiado por el del api del formulario correspondiente),
    private dServiciosDiliParametricas: DDiligenciamientoParametricasServicios,
    private dContextoUsuario: DContextoUsuarioServicio,
    private dReciboPago: DReciboPagoDialogoServicio,
    differ: KeyValueDiffers,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private _servcioParametricasREST: DBasicosParametricasServicios,
    private dBasicosParametricasServicios:DBasicosParametricasServicios,//agregado para consulta UVT

    private datePipe: DatePipe
    //private pago: PagoComponent    
  ) {
    super(
      router,
      activatedRoute,
      dialog,
      dContextoUsuario,
      dNotificacionServicio,
      dPreguntasDialogoServicio,
      dutilidades,
      utilitariosForm,
      dRutServicios,
      dServicioRESTAPI,
      new DFormularioConfiguracion(),
      new DPreguntasFormulario(),
      dlogger,
      differ,
      dServiciosDiliParametricas,
      dReciboPago
    );
    let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
    this.ayudasBaseFormulario = new DAyudasFormulario();
    // this.dDatosCompartidosCabecera = new DDatosCompartidosCabecera();
    this.listCodigosConceptos = new Array<DValorDominio>();
    this.listCodigosConceptosTmp = new Array<DValorDominio>();
    this.fechaPago = this.datePipe.transform(new Date(), 'yyyy-MM-dd', 'UTC-5');
    this.politica401 = new DParametrosPolitica();
    this.reciboPago = new DRtaLiquidacionReciboPago();
    this.modeloDeudorSolidario = new DDeudorSolidarioSubsidiario();
    this.extemporaneidad.esExtemporaneo;
    console.log("->490v7_2.0.3")
  }

  /**
  * @desc Función para llamar todos los metodos que carguen los elementos del formulario
  * como tambien los datos del formulario
  */
  ngOnInit() {


// alert('NgOnInit');
    // this.solicitarIdTributaria();
    setTimeout(() => {
      this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta    
      // this.obtenerDatosParametricas();
      // this.obtenerDepartamentos();
    }, 50);



    this.activatedRoute
      .queryParams
      .subscribe((params: Params) => {
        // si la carga no se hace por medio del metodo consultarFormulario
        if (!params.hasOwnProperty('idedocumento')) {
          this.concepto = params['concepto']; // Query parameter 'concepto'
          this.anio = params['anio']; // Query parameter 'anio'
          this.periodicidad = params['periodicidad']; // Query parameter 'periodicidad'
          this.periodo = params['periodo']; // Query parameter 'periodo'
          
          console.log('concepto:', this.concepto);
          console.log('anio:', this.anio);
          console.log('periodicidad:', this.periodicidad);
          console.log('periodo:', this.periodo);
          // this.parametros.valor=this.concepto;
          // this.parametros.campo='concepto';
          // this.parametros=new Parametros(this.concepto,'concepto')
          // this.parametrosCambio.emit(this.parametros);
          // dDatosCompartidosCabecera.concepto=this.concepto;
          // dDatosCompartidosCabecera.anio=this.anio;
          // dDatosCompartidosCabecera.periodicidad=this.periodicidad;
          // dDatosCompartidosCabecera.periodo=this.periodo;
        }
        if (params.hasOwnProperty('origen')) {
            
            this.origen = params['origen']; // Query parameter 'origen'
            
          }else{
            this.origen = ''; // Query parameter 'origen'
            
          }
      });


    this.inicializeModelo();
    this.inicializeForm();
    this.cargarFechaActual()

    // console.log('=============================this.modelo.doc.cuerpo ' + this.modelo.doc.cuerpo);
    // console.log('=============================dDatosCompartidosCabecera.periodicidad ' + this.dDatosCompartidosCabecera.periodicidad);

  }


  // private cargarFechaVencimiento() {
  //   this.fechaVencimiento = tabla_plazos.tabla_plazos[String(this.anioActual)][String(this.periodo)].Fecha_vencimiento;
  //   console.log(`Fecha de vencimiento: ${this.fechaVencimiento}`);
  // }

  abrirDialogoNIT(): Promise<any> {
    return new Promise((resolve, reject) => {


      const dialogRef = this.dialog.open(ModalIdTributarioComponent);
      console.log(dialogRef);

      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró:', result);
        resolve(result); // Resolvemos la promesa con el resultado del diálogo
      });

    }
    );
  }

  protected inicializeModelo() {
    if (this.modelo.doc.cuerpo.cc_id_50 == undefined) {
      this.modelo.doc.cuerpo.cc_id_50 = [];
    }

    if (this.modelo.doc.cuerpo.cc_id_51 == undefined) {
      this.modelo.doc.cuerpo.cc_id_51 = [];
    }

    if (this.modelo.doc.cuerpo.cc_id_52 == undefined) {
      this.modelo.doc.cuerpo.cc_id_52 = [];
    }

    if (this.modelo.doc.cuerpo.cc_id_53 == undefined) {
      this.modelo.doc.cuerpo.cc_id_53 = [];
    }

    if (this.modelo.doc.cuerpo.cc_id_54 == undefined) {
      this.modelo.doc.cuerpo.cc_id_54 = [];
    }

    if (this.modelo.doc.cuerpo.cc_id_55 == undefined) {
      this.modelo.doc.cuerpo.cc_id_55 = [];
    }


    if (this.modelo.doc.cuerpo.cc_id_56 == undefined) {
      this.modelo.doc.cuerpo.cc_id_56 = [];
    }

    if (this.modelo.doc.cuerpo.cs_id_70 == undefined) {
      this.modelo.doc.cuerpo.cs_id_70 = 0;
    }
    '0'
  }

  /**
  * @implements Funcion que comunica desde la clase padre que el documento se ha cargado correctamente
  */
  protected onInitFormulario() {
    this.obtenerDatosParametricas();
    this.obtenerDepartamentos();


    // Este metodo se ejecuta una vez la clase abstracta ha terminado su proceso y el formulario esta listo para ser diligenciado, aca se puede poner la logica que sea necesaria despues de que el formulario se encuentre listo                                

    this.cas2valor = this.modelo.doc.cab.cs_id_2;
    this.modelo.doc.cab.cs_id_3 = this.periodicidad=='aperiodico'?'1': this.periodo;
    this.modelo.doc.cuerpo.cs_id_32 = this.fechaPago.replace(/\//g, '-');
    this.mostrarPagarBtn = false;

    if (this.modelo.doc.cuerpo.cs_id_24 == "true" || this.modelo.doc.cuerpo.cs_id_24 == "X") {
      this.modelo.doc.cuerpo.cs_id_24 = true;
    }
    else {
      this.modelo.doc.cuerpo.cs_id_24 = false;
    }

    if (this.modelo.doc.cab.cs_id_4 == null) {
      this.modelo.doc.cuerpo.cs_id_27 = "1";
      this.modelo.doc.cuerpo.cs_id_28 = "1";
    }
    
    //Obtener UVT
    this.obtenerValorUVT(this.anioActual); //Al finalizar este servicio se llama a Obtener Actividades Economicas
    this.definirCas34y35();
    // this.cargarFechaVencimiento();

  }




  private obtenerValorUVT(anioDeclaracion){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    anioDeclaracion = Number(anioDeclaracion);
    this.dBasicosParametricasServicios.obtenerValorPeriodico(110,Number(anioDeclaracion)).subscribe( //110 es el codigo de UVT
      res=>{
          let valorPeriodico = <DValorPeriodico>res;
          this.UVT = String(valorPeriodico.valor);
          this.DIEZ_UVT=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.UVT, '10');
          this.DIEZ_UVT = this.dutilidades.redondearValorMoneda(this.DIEZ_UVT,true);

          precargaProceso.close();
          // alert(`$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ UVT para ${this.fechaActual} = ${this.UVT}`);
          console.log(`$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ UVT para ${this.fechaActual} = ${this.UVT}`);
          console.log(`$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ 10UVT para ${this.fechaActual} = ${this.DIEZ_UVT}`);
        },error=>{
          console.log('error consultando valor UVT: '+error);
          precargaProceso.close();
        }
    );    
  }






  /**
  * @implements Funcion que comunica cuando el cuestionario ha sido contestado por si se requiere realizar alguna tarea adicional
  * @param {Any} respuestas
  */
  protected onInitCuestionario(respuestas: any) {
  }


  /**
  * @implements Funcion que comunica cuando el modelo ha tenido un cambio
  * @param {Any} attrModelo
  */
  protected onChangeModelo(attrModelo: any) {
    if(this.extemporaneidad.esExtemporaneo){
      this.extemporaneo=this.extemporaneidad.esExtemporaneo;
    }
console.log(`extemporaneidad: ${this.extemporaneo}`);
  }


  /**
  * @implements Funcion abstracta que comunica al hijo cuando se ha ejecutado un evento sobre el formulario
  * @param {String} evento
  */
  protected eventFormulario(evento: string) {
    //Si es borrador no muestra botón de generar PDF        
    if (this.mostrarGuardarBtn == true) {
      this.mostrarPdfBtn = false;
    }
  }


  // ====== Metodos creados por el desarrollador para operaciones con casillas y otras como (validacionesEnCampos, etc) ======
  /**
  * @desc Funcion casilla 27 para validar
  */
  private operacionCs27(): void {
    console.log('operacionCs27');
    let cas27 = this.modelo.doc.cuerpo.cs_id_27;
    let cas28 = this.modelo.doc.cuerpo.cs_id_28;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas27, cas28) ? true : false) {
      this.modelo.doc.cuerpo.cs_id_27 = String("1");
      this.modelo.doc.cuerpo.cs_id_28 = String("1");
      this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 27 no puede ser mayor al de la casilla 28");
    }
  }


  /**
  * @desc Funcion casilla 28 para validar
  */
  private operacionCs28(): void {
    console.log('operacionCs28');
    let cas27 = this.modelo.doc.cuerpo.cs_id_27;
    let cas28 = this.modelo.doc.cuerpo.cs_id_28;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas28, cas27) ? true : false) {
      this.modelo.doc.cuerpo.cs_id_27 = String("1");
      this.modelo.doc.cuerpo.cs_id_28 = String("1");
      this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 28 no puede ser inferior al de la casilla 27");
    }
  }


  convertirFecha(fecha: string): Date {
    // Verificar que la fecha tiene el formato adecuado
    if (fecha.length === 8) {
      const anio = parseInt(fecha.substring(0, 4), 10);
      const mes = parseInt(fecha.substring(4, 6), 10) - 1; // Mes en JavaScript es 0-indexado
      const dia = parseInt(fecha.substring(6, 8), 10);
  
      return new Date(anio, mes, dia);
    }
    throw new Error('El formato de la fecha es incorrecto, debe ser YYYYMMDD.');
  }
  





  
  /**
  * @desc Funcion casilla 35 para validar
  */
  public operacionCs35(): void {

    console.log('operacionCs35');


    let cas35 = this.modelo.doc.cuerpo.cs_id_35;
    if (/*this.modelo.doc.cab.cs_id_2 =='52'||*/this.modelo.doc.cab.cs_id_2 == '53') {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas35, '0') ? true : false) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 35 no puede ser 0");
      }
    } else {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas35, '0') ? true : false) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 35 no puede ser menor a 0");
      }
    }
  }


  /**
  * @desc Funcion casilla 70 para validar
  */
  private operacionCs70(): void {
    console.log('operacionCs70');
    this.modelo.doc.cuerpo.cs_id_70 = this.modelo.doc.cuerpo.cs_id_70!=undefined?this.modelo.doc.cuerpo.cs_id_70:0;
    let cas70 = this.modelo.doc.cuerpo.cs_id_70!=undefined?this.modelo.doc.cuerpo.cs_id_70:0;
    let cas2 = this.modelo.doc.cab.cs_id_2;
    if (/*cas2 == '52'||*/cas2 == '53') {
      this.modelo.doc.cuerpo.cs_id_36=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, cas70, '100');
      this.modelo.doc.cuerpo.cs_id_36 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_36, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas70, '0') ? true : false) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 70 debe ser mayor a 0");
        // alert("El valor de la casilla 70 debe ser mayor a 0");
      }
    } else {
      this.modelo.doc.cuerpo.cs_id_36='0'
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas70, '0') ? true : false) {
        this.modelo.doc.cuerpo.cs_id_70 = 0;
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 70 debe ser 0");
      }
    }
    // if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas70, '0')) {
    //   this.operacionCs35();
    // }


    let liquidacionRecibo: DLiquidacionRecibo = new DLiquidacionRecibo();

    
    if (this.modelo.doc.cab.cs_id_2=='81') {
      liquidacionRecibo.formato = 2000;
      liquidacionRecibo.concepto.id = "81";
      liquidacionRecibo.concepto.nombre = "Contribución Fondo Nacional de Parque Automotor de Carga";
      liquidacionRecibo.version = 9;
      liquidacionRecibo.formulario = 20000000000000;
    }else{
      liquidacionRecibo.formato = 3111;
      liquidacionRecibo.version = 1;
      liquidacionRecibo.formulario = 31110000000000;

    }
    
    
    liquidacionRecibo.esEditable = true;
    liquidacionRecibo.totalValorMonetario = new DValorMonetarioDetalle();
    liquidacionRecibo.totalValorMonetario.impuesto = this.modelo.doc.cuerpo.cs_id_36;
    liquidacionRecibo.totalValorMonetario.interes = '0';
    liquidacionRecibo.totalValorMonetario.sancion = '0';
    // liquidacionRecibo.totalValorMonetario.totalPagar = this.modelo.doc.cuerpo.cs_id_70;// '0';
    liquidacionRecibo.concepto = new DConceptoLiquidacionRecibo();
    if(this.modelo.doc.cab.cs_id_2=='53'){
      liquidacionRecibo.concepto.id = "53";
      liquidacionRecibo.concepto.nombre = "Impuesto Especial para el Catatumbo";
    }
    // if(this.modelo.doc.cab.cs_id_2=='52'){
    //   liquidacionRecibo.concepto.id = "52";
    //   liquidacionRecibo.concepto.nombre = "Impuesto Especial para la estabilidad fiscal";
    // }

    liquidacionRecibo.conceptos.push(liquidacionRecibo.concepto)
    liquidacionRecibo.anio = Number(this.paramsUrl.anio);
    liquidacionRecibo.periodo = Number(this.paramsUrl.periodo);// Number(this.periodo.id);//this.mesActual;
    // liquidacionRecibo.numCuota = 1;
    // liquidacionRecibo.totalCuotas = "1";
    
    // let fechaStr=this.tabla_plazos[String(this.anioActual)][String(this.periodo)].Fecha_vencimiento
    // liquidacionRecibo.fechaVencimientoPago = new Date(parseInt(fechaStr.substring(0, 4), 10),parseInt(fechaStr.substring(4, 6), 10) - 1,parseInt(fechaStr.substring(6, 8), 10));//99991231;//99991231;//

    // liquidacionRecibo.formulario=this.modelo.doc.cuerpo.cs_id_29;
    liquidacionRecibo.ideDocumento = this.modelo.doc.cuerpo.cs_id_29==undefined||this.modelo.doc.cuerpo.cs_id_29==null?0:this.modelo.doc.cuerpo.cs_id_29;//0;
    // liquidacionRecibo.repeticionFormulario = 1;
    liquidacionRecibo.fechaPago = this.modelo.doc.cuerpo.cs_id_32;//.replace(/-/g, '-');
    
    "ideFormatoFuente={ideFormatoFuente}&numVersionFormatoFuente={numVersionFormatoFuente}&annoGravable={annoGravable}&periodo={periodo}&idePeriodicidad={idePeriodicidad}&codConcepto={codConcepto}&fechaPago={fechaPago}&valorImpuesto= {valorImpuesto}";

    if(this.paramsUrl.periodicidad=='mensual'){console.log('>>>>>>>>>>>>>>> cálculo del intereés <<<<<<<<<<<<')
    let periodicidad='mensual';
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dServicioRESTAPI.calcularInteresReciboSinIdFormulario(liquidacionRecibo,periodicidad).subscribe({
      next: (resp) => {
        // Aquí manejas la respuesta exitosa

        if (resp.codigoRespuesta!=200) {
          // Si hay un error en la respuesta
          this.dNotificacionServicio.mostrarDialogoError(`Error calculando interes del recibo código: ${resp.codigo} 
          mensaje: ${(resp as DError).mensaje} 
          descripción: ${(resp as DError).descripcion}`);
          precargaProceso.close();
        } else {
          // Si la respuesta es un recibo calculado
          
          console.log('resp.valorInteres: '+resp.valorInteres);
         this.modelo.doc.cuerpo.cs_id_35=this.dutilidades.redondearValorMoneda(resp.valorInteres, true);
         
         this.operacionCs980();

         precargaProceso.close();
        }
      },
      error: (err) => {
        // Aquí manejas cualquier error en la suscripción
        this.dNotificacionServicio.mostrarDialogoError(`Error calculando interes del recibo código: ${err.codigo}` 
          // mensaje: ${err.mensaje} 
          // descripción: ${err.descripcion}`
        );
        console.error(err);
        precargaProceso.close();
      }
    });
  }








  }
  

  private anular70() {
    if (/*this.modelo.doc.cab.cs_id_2 != '52'&&*/this.modelo.doc.cab.cs_id_2 != '53') {
      this.modelo.doc.cuerpo.cs_id_70 = 0;
      this.modelo.doc.cuerpo.cs_id_36 = 0;
    }
  }

  private habilitarRazonSocial(){
    console.log('+++++++++++++++++++++===habilitarRazonSocial')
    if (
      this.modelo.doc.cuerpo.cs_id_40===undefined||this.modelo.doc.cuerpo.cs_id_40===''
      &&
      this.modelo.doc.cuerpo.cs_id_41===undefined||this.modelo.doc.cuerpo.cs_id_41===''
      &&
      this.modelo.doc.cuerpo.cs_id_42===undefined||this.modelo.doc.cuerpo.cs_id_42===''
      &&
      this.modelo.doc.cuerpo.cs_id_43===undefined||this.modelo.doc.cuerpo.cs_id_43===''
    ) {
      this.habilitaRazonSocial=true;
    }else{
      this.habilitaRazonSocial=false;
    }
  }

  /**
  * @desc Funcion casilla 980 para calcular el Valor pago intereses de mora
  */
  public operacionCs980(): void {
    console.log('operacionCs980');
    let campos_34_35_36;
    // if(this.modelo.doc.cab.cs_id_2=='81'){
    //   campos_34_35_36 = ['cs_id_90', 'cs_id_34', 'cs_id_35', 'cs_id_36'];
    // }else{
      campos_34_35_36 = ['cs_id_34', 'cs_id_35', 'cs_id_36'];
    // }


    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos_34_35_36, true);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    let valorFormateado = this.dutilidades.deshacerFormatoMoneda(valorRedondeado);
    if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorFormateado, "0") ) {
      this.modelo.doc.pie.cs_id_980 = String(valorFormateado);
    }
    else {


      this.modelo.doc.pie.cs_id_980 = "0";
      return;
    }
  }

public operacionCs34(){
  console.log('operacionCs34');
  if (/*this.modelo.doc.cab.cs_id_2=='52'||*/this.modelo.doc.cab.cs_id_2=='53') {
    if (this.extemporaneo && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelo.doc.cuerpo.cs_id_34, this.DIEZ_UVT)) {
      this.dNotificacionServicio.mostrarDialogoError(`El valor de la casilla 34 no puede ser inferior a 10UVT = ${this.DIEZ_UVT} para el concepto ${this.modelo.doc.cab.cs_id_2}`);
      // this.modelo.doc.cuerpo.cs_id_34=String(this.DIEZ_UVT);
    }    
  }else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelo.doc.cuerpo.cs_id_34, "0")) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelo.doc.cuerpo.cs_id_34, this.DIEZ_UVT)) {
      this.dNotificacionServicio.mostrarDialogoError(`Si paga sanción (casilla 34), esta no puede ser inferior a 10UVT = ${this.DIEZ_UVT}`);
      
    }
  }
  // this.operacionCs35();
}

  public operacionCs90() {
    console.log('operacionCs90');

    if (this.modelo.doc.cab.cs_id_2 === '81') {

      const valor = this.modelo.doc.cuerpo.cs_id_90;

      // Validar null, undefined o vacío
      if (valor === null || valor === undefined || valor === '') {
        this.modelo.doc.cuerpo.cs_id_90 = '0';
        return;
      }

      // Validación numérica
      if (
        this.dutilidades.validacionesNumericas(
          DTipoOperacionAritmetica.MENOR_QUE,
          valor,
          '0'
        )
      ) {
        this.modelo.doc.cuerpo.cs_id_90 = '0';
        this.dNotificacionServicio.mostrarDialogoError(
          'El valor de la casilla 90 debe ser mayor a 0'
        );
      }
    }
  }





  protected onUploadFiles(docs: Array<DArchivoBlob>) { }


  /**
  * @desc Funcion para guardar o actualizar el borrador del formulario
  */
  protected validarGuardarActualizarBorrador() {
    this.modelo.doc.cuerpo.cs_id_25 = null;
    this.modelo.doc.cuerpo.cs_id_29 = null;
    // this.modelo.doc.cuerpo.cs_id_30 = null;
    this.modelo.doc.cuerpo.cs_id_47 = this.modeloDeudorSolidario.departamento.codigo;
    this.modelo.doc.cuerpo.cs_id_48 = this.modeloDeudorSolidario.ciudad.codigo;

    if (this.modelo.doc.cab.cs_id_2 == null || this.modelo.doc.cab.cs_id_2 == "undefined") {
      this.dNotificacionServicio.mostrarDialogoError("Debe seleccionar un valor para la casilla 2");
    }
    if (this.modelo.doc.cab.cs_id_2 == '53'/*||this.modelo.doc.cab.cs_id_2 == '52'*/) {
      if (this.modelo.doc.cuerpo.cs_id_70 == null || this.modelo.doc.cuerpo.cs_id_70 == "undefined" 
        // || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.modelo.doc.cuerpo.cs_id_70, '0') 
        || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.modelo.doc.cuerpo.cs_id_70, '999')) {
        this.dNotificacionServicio.mostrarDialogoError("Debe digitar un valor mayor a cero en la casilla 70");
        this.modelo.doc.cuerpo.cs_id_70 = '0';
        return;
      }else {
        this.operacionCs980();
        if (/*this.modelo.doc.cab.cs_id_2=='52'||*/this.modelo.doc.cab.cs_id_2=='53') {
          if (this.extemporaneo && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelo.doc.cuerpo.cs_id_34, this.DIEZ_UVT)) {
            this.dNotificacionServicio.mostrarDialogoError(`El valor de la casilla 34 no puede ser inferior a 10UVT = ${this.DIEZ_UVT} para el concepto ${this.modelo.doc.cab.cs_id_2}`);
            this.modelo.doc.cuerpo.cs_id_34=String(this.DIEZ_UVT);
            this.operacionCs980();
            return;
          }    
        }else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelo.doc.cuerpo.cs_id_34, "0")) {
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelo.doc.cuerpo.cs_id_34, this.DIEZ_UVT)) {
            this.dNotificacionServicio.mostrarDialogoError(`Si paga sanción (casilla 34), esta no puede ser inferior a 10UVT = ${this.DIEZ_UVT}`);
            return;
          }
        }
        this.guardarActualizarBorrador();
      }
    }
    // else if (this.modelo.doc.cab.cs_id_2 == '81') {
    //   let val90 = this.modelo.doc.cuerpo.cs_id_90;
    //   if (val90 === null || val90 === undefined || val90 === '' || val90 === '0') {
    //     this.dNotificacionServicio.mostrarDialogoError('La casilla 90 debe tener un valor mayor a 0 para el concepto 81.');
    //     return;
    //   }
    //   let val91 = this.modelo.doc.cuerpo.cs_id_91;
    //   if (val91 === null || val91 === undefined || val91 === '' || val91 === '0') {
    //     this.dNotificacionServicio.mostrarDialogoError('La casilla 91 debe ser diligenciada con el número del manifiesto de carga.');
    //     return;
    //   }
    //   this.operacionCs980();
    //   this.guardarActualizarBorrador();
    // }
    else if (this.modelo.doc.cab.cs_id_2 == '7') {
      // obligatoriedad del diligenciamiento de las casillas 30 y 31 para el concepto 7 
      // será aplicada a partir del 6 de marzo de 2026.
      let fecha6marzo2026=20260306;
      // let fecha6marzo2026=20260226;
      let fechaPago = parseInt (this.modelo.doc.cuerpo.cs_id_32.replace(/-/g, ''));
      if (fechaPago>=fecha6marzo2026) {
        let val30 = this.modelo.doc.cuerpo.cs_id_30;
        if (val30 === null || val30 === undefined || val30 === '' || val30 === '0') {
          this.dNotificacionServicio.mostrarDialogoError('La casilla 30 debe ser diligenciada con el número del acto oficial para el concepto 7.');
          return;
        }
        
        if (Number(val30) <= 100) {
          this.dNotificacionServicio.mostrarDialogoError('La casilla 30 debe tener un número mayor a 100.');
          return;
        }

        let val31 = this.modelo.doc.cuerpo.cs_id_31;
        if (val31 === null || val31 === undefined || val31 === '' || val31 === '0') {
          this.dNotificacionServicio.mostrarDialogoError('La casilla 31 debe ser diligenciada con la fecha del acto oficial para el concepto 7.');
          return;
        }

        // Validación de fecha menor o igual a hoy
        const fechaSeleccionada = new Date(val31);
        const fechaHoy = new Date();

        // Eliminamos las horas, minutos y segundos para comparar solo el "día"
        fechaHoy.setHours(0, 0, 0, 0);

        if (fechaSeleccionada > fechaHoy) {
          this.dNotificacionServicio.mostrarDialogoError('La fecha de la casilla 31 no puede ser mayor a la fecha actual.');
          return;
        }
      }
      this.operacionCs980();
      let val980=this.modelo.doc.pie.cs_id_980;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, val980, "0") ) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 980 debe ser mayor a 0, verifique los valores de las casillas 34, 35 y 36");
        return;
      }
      this.guardarActualizarBorrador();
    } else if (this.modelo.doc.cab.cs_id_2 != '7') {
      this.operacionCs980();
      let val980 = this.modelo.doc.pie.cs_id_980;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, val980, "0")) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 980 debe ser mayor a 0, verifique los valores de las casillas 34, 35 y 36");
        return;
      }
      this.guardarActualizarBorrador();
    }
    else {
      if (this.stateInput && this.stateInput.error) {
        this.dNotificacionServicio.mostrarDialogoError('Error llene los campos correctamente');
      }
      else {
        this.operacionCs980();
        this.guardarActualizarBorrador();
      }
    }
  }


  protected cargarFechaActual() {
    // Obtener la fecha actual
    const today = new Date();
    // Convertir la fecha al formato yyyy-MM-dd
    this.modelo.doc.cuerpo.cs_id_32 = today.toISOString().split('T')[0]; // "yyyy-MM-dd"

        // Asignar el año y el mes a las variables correspondientes
        this.anioActual = today.getFullYear(); // Año actual
        this.mesActual = today.getMonth() + 1; // Mes actual (0-11, por eso sumamos 1)
        this.fechaActual=this.modelo.doc.cuerpo.cs_id_32;
  }

  verificarFecha(){
    let fechaModificada=this.modelo.doc.cuerpo.cs_id_32;
    fechaModificada = new Date(fechaModificada);
    if(fechaModificada.getFullYear()!=this.anioActual||
    fechaModificada.getMonth()+1!=this.mesActual){
      this.dNotificacionServicio.mostrarDialogoError('La fecha debe pertenecer al mismo mes y año de presentación');
      console.log('La fecha debe pertenecer al mismo mes y año de presentación');
      this.modelo.doc.cuerpo.cs_id_32=this.fechaActual;
    }
  }
  
  definirCas34y35() {
    let fechaModificada = this.modelo.doc.cuerpo.cs_id_32.replace(/-/g, '');
    // fechaModificada = new Date(fechaModificada);
    let periodo = this.dDatosCompartidosCabecera.periodo;
    let concepto = this.modelo.doc.cab.cs_id_2;
    let periodicidad = this.dDatosCompartidosCabecera.periodicidad;
    if (periodicidad=='mensual'&&(/*concepto=='52'||*/concepto=='53')) {
      if (periodo != null) {
        // this.fechaVencimiento = this.tabla_plazos[String(this.anioActual)][String(periodo)].Fecha_vencimiento;
        // fechaVencimiento = new Date(fechaVencimiento);
        if (fechaModificada >= this.fechaVencimiento) {
          this.habilitarCas34y35 = true;
          console.log('==========================Es extemporaneo');
        } else {
          this.habilitarCas34y35 = false;
          console.log('==========================No es extemporaneo');
  
        }
      }
    }

  }



  /**
  * @desc Funcion para guardar o actualizar el borrador del formulario
  */
  protected validarGuardarFormularioDefinitivo() {

    this.modelo.doc.cuerpo.cs_id_25 = null;
    this.modelo.doc.cuerpo.cs_id_29 = null;
    // this.modelo.doc.cuerpo.cs_id_30 = null;
    this.modelo.doc.cuerpo.cs_id_47 = this.modeloDeudorSolidario.departamento.codigo;
    this.modelo.doc.cuerpo.cs_id_48 = this.modeloDeudorSolidario.ciudad.codigo;

    if (this.modelo.doc.cab.cs_id_2 == null || this.modelo.doc.cab.cs_id_2 == "undefined") {
      this.dNotificacionServicio.mostrarDialogoError("Debe seleccionar un valor para la casilla 2");
    }
    else {
      if (this.stateInput && this.stateInput.error) {
        this.dNotificacionServicio.mostrarDialogoError('Error llene los campos correctamente');
      }
      else {
        this.operacionCs980();
        this.guardarFormularioDefinitivo();
      }
    }
  }

resp=undefined;
  private obtenerDatosParametricas() {
    console.log('=============================this.modelo.doc.cuerpo ' + this.modelo.doc.cuerpo);
    console.log('=============================dDatosCompartidosCabecera.periodicidad ' + this.dDatosCompartidosCabecera.periodicidad);
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerValoresDominio('1631')
      .subscribe(
        res => {
          console.log('Respuesta del servidor:', res);
          if (Array.isArray(res)) {




            this.listCodigosConceptos = res as Array<DValorDominio>;
            this.listCodigosConceptosTmp = [];

            for (let index = 0; index < this.listCodigosConceptos.length; index++) {
              console.log('origen-------------->'+this.dDatosCompartidosCabecera.origen);
              if (this.dDatosCompartidosCabecera.periodicidad != 'mensual') {
                if (this.listCodigosConceptos[index].valor != '52'&&this.listCodigosConceptos[index].valor != '53'&&this.listCodigosConceptos[index].valor != '81') {

                  if ((this.listCodigosConceptos[index].valor == '75'&&this.dDatosCompartidosCabecera.anio >= 2026)||this.listCodigosConceptos[index].valor != '75') {
                    this.listCodigosConceptosTmp.push(this.listCodigosConceptos[index]);
                  }
                }
              }
              if (this.dDatosCompartidosCabecera.periodicidad == 'mensual') {
                if(this.listCodigosConceptos[index].valor == '81'&&this.dDatosCompartidosCabecera.anio==2026&&this.origen=='contribucionmintransporte')
                  {
                    this.listCodigosConceptosTmp.push(this.listCodigosConceptos[index]);
                    this.modelo.doc.cab.cs_id_2='81';
                  }
                  
                  
                  
                  
                  if(this.listCodigosConceptos[index].valor == '53'&&this.dDatosCompartidosCabecera.anio >= 2025&&this.origen!='contribucionmintransporte')
                    {
                      this.listCodigosConceptosTmp.push(this.listCodigosConceptos[index]);
                      this.modelo.doc.cab.cs_id_2='53';
                    }     
                  }
                }
                this.listCodigosConceptosTmp=this.ordenarLista(this.listCodigosConceptosTmp);
                this.habilitaCasillas();
          } else {
            console.error('La respuesta no es un array:', res);
          }
          setTimeout(() => {
            
           

          }, 2000);
          preloader.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        },
        
      () => {
        // Este bloque se ejecuta cuando el Observable completa su flujo
        console.log('El Observable completó su ejecución.');
      }

      );

  }




  public getDate(dateString: string): Date {
    let splitDate = dateString.split('-');
    let date = new Date(Number(splitDate[0]), Number(splitDate[1]), Number(splitDate[2]));
    return date;
  }


  public getEventInputDateMask(event: { error: boolean, message: string, dateString: string }) {
    this.stateInput = event;
  }


  /**
  * @desc Funcion para pagar el formulario
  * @param {String} fecha
  * @param {String} mensajeAntesGuardar
  */
  protected pagarFormularioEnLinea() {
    let dialogo = {
      //height: '1200px',
      //width: '600px',
      disableClose: true
    };
    let dialogRef = this.dialog.open(PagoComponent, dialogo);
    dialogRef.componentInstance.reciboPago.ideDocumento = this.modelo.doc.cab.cs_id_4;
    dialogRef.componentInstance.fechaPago = this.modelo.doc.cuerpo.cs_id_32;
    dialogRef.componentInstance.contextoUsuario.NitOrganizacion = this.modelo.doc.cab.cs_id_5;
    dialogRef.componentInstance.modelo.anio = this.modelo.doc.cab.cs_id_1;
    dialogRef.componentInstance.modelo.periodo = this.modelo.doc.cab.cs_id_3;
    dialogRef.componentInstance.totalPagar = String(this.modelo.doc.pie.cs_id_980);
    //dialogRef.componentInstance.contextoUsuario = this.datosContexto;
    //dialogRef.componentInstance.modelo = this.modelo;
    //dialogRef.componentInstance.tieneFirmaElectronica = this.firmaRequerida;
    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog result: ', result);
    });
  }

  /**
  * @desc Funcion para liquidar el formulario y realizar el pago
  * @param {String} idDocumento
  * @param {String} fecha
  * @return {Observable<DRespuestaSimple|DError>}
  */
  public liquidarFormulario(idDocumento: string, fecha?: string): Observable<DLiquidacionRecibo | DError> {
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioREST.generarLiquidacionReciboPago(idDocumento, fecha);
    observableServicio.subscribe(
      res => {
        precargaProceso.close();
        this.dNotificacionServicio.mostrarDialogoInformacion('Liquidación generada');
      },
      error => {
        precargaProceso.close();
        this.dNotificacionServicio.mostrarDialogoError("Error liquidando recibo", error.mensaje);
      }
    );

    return observableServicio;
  }


  public obtenerDepartamentos() {
    // let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerDepartamentos()
      .subscribe(
        res => {
          this.listDptos = <Array<DLugar>>res;
          // preloader.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error obteniendo datos de parametricas', error.descripcion);
          // preloader.close();
        }
      );
  }


  public obtenerCiudades() {
    const BOGOTADC = '11';
    const BOGOTADC_CIUDAD = '11001';

    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerCiudades(null, this.modeloDeudorSolidario.departamento.codigo)
      .subscribe(
        res => {
          let listLocal = <Array<DLugar>>res;
          if (BOGOTADC === this.modeloDeudorSolidario.departamento.codigo) {
            this.listMpios = new Array<DLugar>();
            this.listMpios.push(listLocal[0]);
          } else this.listMpios = listLocal;
          preloader.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        }
      );
  }

  public agregarImpuestosSimple() {
    const id = 0;
    const conceptoPago = 0;
    const numeroDeclaracion = 0;
    const numeroDocumentoOrigen = 0;
    const valorImpuesto = 0;
    const valorInteresMora = 0;
    const valorSancion = 0;
    const total = 0;

    this.impuestosSimple.push(

      new DForm1(

        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      )
    )
  }




  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      //this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        console.log('this.operacionTabla == this.OPERACION_EDITAR');
        if (!this.totalCero()) {
          console.log('!this.totalCero()');
          this.editModeloDesdeForm();
        }
        return;
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        if (this.conceptoExiste()) {
          let dialogError = this.dNotificacionServicio.mostrarDialogoError("El concepto ya está adicionado, por favor revise");
          return;
        }
        if (this.totalCero()) {
          let dialogError = this.dNotificacionServicio.mostrarDialogoError("Por lo menos una de las casillas 53, 54 o 55 debe registrar un valor mayor a cero, por favor revise");
          return;
        }
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs56();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.modelo);
    }
  }

  conceptoExiste() {
    for (let elemento of this.dataSourceBody) {
      if ((elemento as Form1).conceptoPago == this.modelForm.conceptoPago) {
        return true;
      }
    }
    return false;
  }

  totalCero() {
    if (this.modelForm.valorImpuesto == 0 && this.modelForm.valorInteresMora == 0 && this.modelForm.valorSancion == 0) {
      return true;
    }
    return false;
  }


  protected async inicializeForm() {



    // const resultadoDialogo = await this.abrirDialogoNIT(); //Llama popup para ingresar identificación tributaria (NIT)
    // this.modelo.doc.cab.cs_id_5=resultadoDialogo;
    // console.log('Resultado del diálogo:', resultadoDialogo);
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.conceptoPago = 0;
    this.modelForm.numDeclaracion = 0;
    this.modelForm.numDocumentoOrigen = 0;
    this.modelForm.valorImpuesto = 0;
    this.modelForm.valorInteresMora = 0;
    this.modelForm.valorSancion = 0;
    this.modelForm.total = 0;

  }

  public validateFormCompleted(): boolean {
    console.log(`validateFormCompleted()`);
    console.log(`conceptoPago: ${this.modelForm.conceptoPago}`);
    console.log(`numDeclaracion: ${this.modelForm.numDeclaracion}`);
    console.log(`numDocumentoOrigen: ${this.modelForm.numDocumentoOrigen}`);
    console.log(`valorImpuesto: ${this.modelForm.valorImpuesto}`);
    console.log(`valorInteresMora: ${this.modelForm.valorInteresMora}`);
    console.log(`valorSancion: ${this.modelForm.valorSancion}`);
    console.log(`total: ${this.modelForm.total}`);
    console.log((this.modelForm.conceptoPago == undefined || this.modelForm.conceptoPago == 0 ||
      this.modelForm.numDeclaracion == undefined || this.modelForm.numDeclaracion == 0 ||
      this.modelForm.numDocumentoOrigen == undefined || this.modelForm.numDocumentoOrigen == 0 ||

      this.modelForm.valorImpuesto == undefined ||
      this.modelForm.valorInteresMora == undefined ||
      this.modelForm.valorSancion == undefined ||
      this.modelForm.total == undefined
    ));
    return (this.modelForm.conceptoPago == undefined || this.modelForm.conceptoPago == 0 ||
      this.modelForm.numDeclaracion == undefined || this.modelForm.numDeclaracion == 0 ||
      this.modelForm.numDocumentoOrigen == undefined || this.modelForm.numDocumentoOrigen == 0 ||

      this.modelForm.valorImpuesto == undefined ||
      this.modelForm.valorInteresMora == undefined ||
      this.modelForm.valorSancion == undefined ||
      this.modelForm.total == undefined
    );
  }


  public editModeloDesdeForm() {
    console.log('Edit modelo desde form');
    this.modelo.doc.cuerpo.cc_id_50[this.modelForm.id].v = this.modelForm.conceptoPago;
    this.modelo.doc.cuerpo.cc_id_51[this.modelForm.id].v = this.modelForm.numDeclaracion.toString();;
    this.modelo.doc.cuerpo.cc_id_52[this.modelForm.id].v = this.modelForm.numDocumentoOrigen.toString();
    this.modelo.doc.cuerpo.cc_id_53[this.modelForm.id].v = this.modelForm.valorImpuesto.toString();
    this.modelo.doc.cuerpo.cc_id_54[this.modelForm.id].v = this.modelForm.valorInteresMora.toString();
    this.modelo.doc.cuerpo.cc_id_55[this.modelForm.id].v = this.modelForm.valorSancion.toString();
    this.modelo.doc.cuerpo.cc_id_56[this.modelForm.id].v = this.modelForm.total.toString();

  }


  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.modelo.doc.cuerpo.cc_id_50.push({ it: i, v: this.modelForm.conceptoPago.toString() });
    this.modelo.doc.cuerpo.cc_id_51.push({ it: i, v: this.modelForm.numDeclaracion.toString() });
    this.modelo.doc.cuerpo.cc_id_52.push({ it: i, v: this.modelForm.numDocumentoOrigen.toString() });
    this.modelo.doc.cuerpo.cc_id_53.push({ it: i, v: this.modelForm.valorImpuesto.toString() });
    this.modelo.doc.cuerpo.cc_id_54.push({ it: i, v: this.modelForm.valorInteresMora.toString() });
    this.modelo.doc.cuerpo.cc_id_55.push({ it: i, v: this.modelForm.valorSancion.toString() });
    this.modelo.doc.cuerpo.cc_id_56.push({ it: i, v: this.modelForm.total.toString() });

  }

  public deleteOnModel(index: number) {
    this.modelo.doc.cuerpo.cc_id_50.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_51.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_52.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_53.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_54.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_55.splice(index, 1);
    this.modelo.doc.cuerpo.cc_id_56.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.modelo.doc.cuerpo.cc_id_50.length; i++) {
      this.modelo.doc.cuerpo.cc_id_51[i].it = i + 1;
      this.modelo.doc.cuerpo.cc_id_52[i].it = i + 1;
      this.modelo.doc.cuerpo.cc_id_53[i].it = i + 1;
      this.modelo.doc.cuerpo.cc_id_54[i].it = i + 1;
      this.modelo.doc.cuerpo.cc_id_55[i].it = i + 1;
      this.modelo.doc.cuerpo.cc_id_56[i].it = i + 1;

    }
  }



  public operacionCs56() {
    console.log('--------------->operacionCs56')

    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";
    suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.modelForm.valorImpuesto, suma1);
    suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.modelForm.valorInteresMora, suma1);
    suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.modelForm.valorSancion, suma2);
    this.modelForm.total = parseInt(suma3);
    // this.dataSourceBody[i].total=suma3;



    // this.modelo.doc.cuerpo.cs_id_483 = suma1;
    // this.modelo.doc.cuerpo.cs_id_485 = suma2;
    // this.modelo.doc.cuerpo.cs_id_538 = suma3;
    // this.modelo.doc.cuerpo.cs_id_679 = suma4;

  }
  // public operacionCs56(){

  //   for(let i=0; i<this.dataSourceBody.length; i++){
  //     let suma1 = "0";
  //     let suma2 = "0";
  //     let suma3 = "0";
  //     suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,""+this.dataSourceBody[i].valorImpuesto,suma1);
  //     suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,""+this.dataSourceBody[i].valorInteresMora,suma1);
  //     suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,""+this.dataSourceBody[i].valorSancion,suma2);
  //     this.modelForm.total=parseInt(suma3);
  //     this.dataSourceBody[i].total=suma3;

  //   }

  // this.modelo.doc.cuerpo.cs_id_483 = suma1;
  // this.modelo.doc.cuerpo.cs_id_485 = suma2;
  // this.modelo.doc.cuerpo.cs_id_538 = suma3;
  // this.modelo.doc.cuerpo.cs_id_679 = suma4;

  // }
  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs56();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando

      this.modelForm = this.dataSourceBody[index];


    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
      // console.log(this.model);
    }
  }

  cancel(): void {
    console.log('cancel');
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  public solicitarIdTributaria() {
    let arrayButtons = [
      { text: 'Enviar', value: 1, mdClass: 'primary', disabled: false }
    ]

    let notificacion = this.dNotificacionServicio.mostrarDialogoPersonalizado("Identificación Tributaria", "Ingrese número de Id. Tributaria.......", "Ingrese número de Id. Tributaria.......", arrayButtons, '', '', true);
    notificacion.afterClosed().subscribe(
      result => {
        console.log(result);
      }
    )
  }




  // public obtenerRoles(): Observable<Array<DRol> | DErrorResponse> {



  //   let parametrosServicioMuisca: DParametrosServicioMuisca = new DParametrosServicioMuisca();
  //   let dConfiguracionEndPoint = DConfiguracionEndPoint.getEndPointEnv(this.contextoServicio, version_api, path_configuracion);
  //   parametrosServicioMuisca.setConfiguracionEndPoint(dConfiguracionEndPoint);
  //   parametrosServicioMuisca.setOperacion(DTipoOperacionHttp.Consultar);
  //   parametrosServicioMuisca.setArgumentos('ciudades?' + queryString);
  //   let observableRespuesta = super.ejecutarServicio(parametrosServicioMuisca);
  //   observableRespuesta.subscribe(
  //     respuesta => {
  //       this.logger.info('Servicio obtener roles de basicos parametricas ejecutado correctamente');
  //     }, error => {
  //       this.logger.error('Servicio obtener roles de basicos parametricas ejecutado con error');
  //     });
  //   return observableRespuesta;
  // }


  // 2026/02/03 habilita cas 30 y 31 si concepto=7
  public habilitaCasillas() {
    let valConcepto = this.modelo.doc.cab.cs_id_2;
    if (valConcepto == '7') {
      this.concepto7 = true;
    } else {
      this.concepto7 = false;
    }
    if (valConcepto == '75') {
      this.deshabilitarCas33=false;
    }else{
      this.modelo.doc.cuerpo.cs_id_33="0";
      this.deshabilitarCas33=true;
    }

    if (valConcepto == '7'||valConcepto == '53'||valConcepto == '75'||valConcepto == '81') {
      this.deshabilitarCas27 = true;
      this.deshabilitarCas28 = true;
    } else{
      this.deshabilitarCas27 = false;
      this.deshabilitarCas28 = false;

    }
    
  }



  /**
  * @desc Funcion casilla 70 para validar
  */
  private operacionCs36(): void {
    console.log('operacionCs36');
    this.modelo.doc.cuerpo.cs_id_36 = this.modelo.doc.cuerpo.cs_id_36 != undefined ? this.modelo.doc.cuerpo.cs_id_36 : 0;
    let cas36 = this.modelo.doc.cuerpo.cs_id_36 != undefined ? this.modelo.doc.cuerpo.cs_id_36 : 0;
    let cas2 = this.modelo.doc.cab.cs_id_2;
    if (cas2 == '81') {
      cas36 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, cas36, '1000');
      cas36 = this.dutilidades.redondearValorMoneda(cas36, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas36, '0') ? true : false) {
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 36 debe ser mayor a 0");
        // alert("El valor de la casilla 70 debe ser mayor a 0");
      }
      // } 



      let liquidacionRecibo: DLiquidacionRecibo = new DLiquidacionRecibo();
      liquidacionRecibo.formato = 2000;

      liquidacionRecibo.esEditable = true;
      liquidacionRecibo.totalValorMonetario = new DValorMonetarioDetalle();
      liquidacionRecibo.totalValorMonetario.impuesto = this.modelo.doc.cuerpo.cs_id_36;
      liquidacionRecibo.totalValorMonetario.interes = '0';
      liquidacionRecibo.totalValorMonetario.sancion = '0';
      // liquidacionRecibo.totalValorMonetario.totalPagar = this.modelo.doc.cuerpo.cs_id_70;// '0';
      liquidacionRecibo.concepto = new DConceptoLiquidacionRecibo();
      if (this.modelo.doc.cab.cs_id_2 == '53') {
        liquidacionRecibo.concepto.id = "53";
        liquidacionRecibo.concepto.nombre = "Impuesto Especial para el Catatumbo";
      }
      // if(this.modelo.doc.cab.cs_id_2=='52'){
        //   liquidacionRecibo.concepto.id = "52";
        //   liquidacionRecibo.concepto.nombre = "Impuesto Especial para la estabilidad fiscal";
        // }
        
        if (this.modelo.doc.cab.cs_id_2 == '81') {
          liquidacionRecibo.concepto.id = "81";
          liquidacionRecibo.concepto.nombre = "Contribución Fondo Nacional de Parque Automotor de Carga";
        }
      liquidacionRecibo.conceptos.push(liquidacionRecibo.concepto)
      liquidacionRecibo.anio = Number(this.paramsUrl.anio);
      liquidacionRecibo.periodo = Number(this.paramsUrl.periodo);// Number(this.periodo.id);//this.mesActual;
      // liquidacionRecibo.numCuota = 1;
      // liquidacionRecibo.totalCuotas = "1";
      liquidacionRecibo.version = 9;
      // let fechaStr=this.tabla_plazos[String(this.anioActual)][String(this.periodo)].Fecha_vencimiento
      // liquidacionRecibo.fechaVencimientoPago = new Date(parseInt(fechaStr.substring(0, 4), 10),parseInt(fechaStr.substring(4, 6), 10) - 1,parseInt(fechaStr.substring(6, 8), 10));//99991231;//99991231;//
      liquidacionRecibo.formulario = 20000000000000;

      // liquidacionRecibo.formulario=this.modelo.doc.cuerpo.cs_id_29;
      liquidacionRecibo.ideDocumento = this.modelo.doc.cuerpo.cs_id_29 == undefined || this.modelo.doc.cuerpo.cs_id_29 == null ? 0 : this.modelo.doc.cuerpo.cs_id_29;//0;
      // liquidacionRecibo.repeticionFormulario = 1;
      liquidacionRecibo.fechaPago = this.modelo.doc.cuerpo.cs_id_32;//.replace(/-/g, '-');

      "ideFormatoFuente={ideFormatoFuente}&numVersionFormatoFuente={numVersionFormatoFuente}&annoGravable={annoGravable}&periodo={periodo}&idePeriodicidad={idePeriodicidad}&codConcepto={codConcepto}&fechaPago={fechaPago}&valorImpuesto= {valorImpuesto}";

      if (this.paramsUrl.periodicidad == 'mensual') {
        console.log('>>>>>>>>>>>>>>> cálculo del intereés <<<<<<<<<<<<')
        let periodicidad = 'mensual';
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        this.dServicioRESTAPI.calcularInteresReciboSinIdFormulario(liquidacionRecibo, periodicidad).subscribe({
          next: (resp) => {
            // Aquí manejas la respuesta exitosa

            if (resp.codigoRespuesta != 200) {
              // Si hay un error en la respuesta
              this.dNotificacionServicio.mostrarDialogoError(`Error calculando interes del recibo código: ${resp.codigo} 
          mensaje: ${(resp as DError).mensaje} 
          descripción: ${(resp as DError).descripcion}`);
              precargaProceso.close();
            } else {
              // Si la respuesta es un recibo calculado

              console.log('resp.valorInteres: ' + resp.valorInteres);
              this.modelo.doc.cuerpo.cs_id_35 = this.dutilidades.redondearValorMoneda(resp.valorInteres, true);

              this.operacionCs980();

              precargaProceso.close();
            }
          },
          error: (err) => {
            // Aquí manejas cualquier error en la suscripción
            this.dNotificacionServicio.mostrarDialogoError(`Error calculando interes del recibo código: ${err.codigo}`
              // mensaje: ${err.mensaje} 
              // descripción: ${err.descripcion}`
            );
            console.error(err);
            precargaProceso.close();
          }
        });
      }

    }
  }

  private ordenarLista(data) {
    // const data = [/* tu array de objetos */];

    data.sort((a, b) => {
      // Convertimos los strings a números para la comparación
      return Number(a.valor) - Number(b.valor);
    });

    console.log(data);

    return data;
  }

}




// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/formulario/formulario.component.ts